import React, { useEffect, useState } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { useField } from '@unform/core';

type TVTextFieldProps = TextFieldProps & {
  name: string;
  calcular?: (value: number) => void;
};

export const VFieldMoneyNumber2: React.FC<TVTextFieldProps> = ({
  name,
  calcular,
  ...rest
}) => {
  const {
    fieldName,
    registerField,
    defaultValue = 0,
    error,
    clearError,
  } = useField(name);

  const [value, setValue] = useState<string>(() =>
    formatToBR(defaultValue)
  );

  useEffect(() => {
    registerField({
      name: fieldName,

      // 👉 valor REAL que vai para o formulário
      getValue: () => parseToNumber(value),

      // 👉 quando o valor vem de fora (setFieldValue)
      setValue: (_, newValue: number) => {
        setValue(formatToBR(newValue));
      },

      clearValue: () => setValue('0,00'),
    });
  }, [fieldName, registerField, value]);

  /* ===============================
     Helpers
     =============================== */

  function parseToNumber(val: string): number {
    if (!val) return 0;

    return Number(
      val.replace(/\./g, '').replace(',', '.')
    ) || 0;
  }

  function formatToBR(val: number | string): string {
    const num =
      typeof val === 'number'
        ? val
        : parseToNumber(val);

    return num.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  /* ===============================
     Change handler (DIGITAÇÃO)
     =============================== */
  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    // remove tudo que não for número
    const digitsOnly = e.target.value.replace(/\D/g, '');

    // digitação trabalha em centavos
    const numberValue = Number(digitsOnly) / 100;

    setValue(formatToBR(numberValue));
    calcular?.(numberValue);

    rest.onChange?.(e);
  }

  return (
    <TextField
      {...rest}
      value={value}
      error={!!error}
      helperText={error}
      onChange={handleChange}
      onKeyDown={(e) => {
        if (error) clearError();
        rest.onKeyDown?.(e);
      }}
    />
  );
};
